// French UI Translations for French Schools in Penama Province
// This file contains all UI translations for French schools

// List of all French school IDs
export const FRENCH_SCHOOL_IDS = [
  'school-ambaebulu-french-primary',  // École Primaire Francophone d'Ambaebulu
  'school-college-de-tagaga'          // Collège de Tagaga (Junior Secondary)
];

// Legacy export for backward compatibility
export const FRENCH_SCHOOL_ID = 'school-ambaebulu-french-primary';

export const frenchTranslations = {
  // Dashboard Layout - Sidebar
  sidebar: {
    dashboard: "Tableau de bord",
    home: "Accueil",
    overview: "Aperçu",
    teaching: "Enseignement",
    classes: "Classes",
    rollCall: "Appel",
    students: "Élèves",
    myAttendance: "Ma Présence",
    assessmentGrading: "Évaluation et Notes",
    assessments: "Évaluations",
    submissionsMarking: "Soumissions et Corrections",
    gradeBook: "Carnet de Notes",
    resources: "Ressources",
    curriculum: "Programme",
    primaryCurriculum: "Programme Primaire",
    timetable: "Emploi du Temps",
    studentResources: "Ressources Élèves",
    aiLessonPlanner: "Planificateur IA",
    account: "Compte",
    changePassword: "Changer le Mot de Passe",
    signOut: "Déconnexion",
    administration: "Administration",
    teacherAttendance: "Présence des Enseignants",
    leaveRequests: "Demandes de Congé",
    sendReminders: "Envoyer des Rappels",
    publishReports: "Publier les Bulletins",
    viewReportCards: "Voir les Bulletins",
    resetTermData: "Réinitialiser les Données du Trimestre"
  },

  // Common UI Elements
  common: {
    loading: "Chargement...",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    search: "Rechercher",
    filter: "Filtrer",
    export: "Exporter",
    import: "Importer",
    print: "Imprimer",
    download: "Télécharger",
    upload: "Téléverser",
    submit: "Soumettre",
    confirm: "Confirmer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    yes: "Oui",
    no: "Non",
    all: "Tous",
    none: "Aucun",
    select: "Sélectionner",
    selectAll: "Tout Sélectionner",
    clear: "Effacer",
    reset: "Réinitialiser",
    close: "Fermer",
    open: "Ouvrir",
    view: "Voir",
    details: "Détails",
    actions: "Actions",
    status: "Statut",
    date: "Date",
    time: "Heure",
    name: "Nom",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    description: "Description",
    notes: "Notes",
    comments: "Commentaires",
    total: "Total",
    average: "Moyenne",
    percentage: "Pourcentage",
    grade: "Note",
    score: "Score",
    marks: "Points",
    success: "Succès",
    error: "Erreur",
    warning: "Attention",
    info: "Information"
  },

  // Primary Curriculum Page
  primaryCurriculum: {
    title: "Programme Primaire",
    subtitle: "Années 1-6 - Programme National du Vanuatu",
    selectYear: "Sélectionner l'Année",
    yearLevel: "Niveau Scolaire",
    year: "Année",
    term: "Trimestre",
    week: "Semaine",
    strand: "Domaine",
    subStrand: "Sous-domaine",
    topic: "Sujet",
    learningOutcomes: "Objectifs d'Apprentissage",
    activities: "Activités",
    assessment: "Évaluation",
    resources: "Ressources",
    teachingNotes: "Notes Pédagogiques",
    
    // Tabs
    tabs: {
      curriculum: "Programme",
      lessonPlans: "Plans de Cours",
      assessments: "Évaluations",
      resources: "Ressources",
      aiGenerator: "Générateur IA"
    },

    // Subjects
    subjects: {
      languageCommunication: "Langue et Communication",
      mathematics: "Mathématiques",
      science: "Sciences",
      socialScience: "Sciences Sociales",
      healthPhysicalEducation: "Santé et Éducation Physique",
      artsCreativity: "Arts et Créativité"
    },

    // Strands for Language
    languageStrands: {
      listeningAndSpeaking: "Écoute et Expression Orale",
      reading: "Lecture",
      writing: "Écriture",
      handwriting: "Écriture Manuscrite"
    },

    // Strands for Mathematics
    mathStrands: {
      number: "Nombres",
      measurement: "Mesures",
      geometry: "Géométrie",
      statistics: "Statistiques"
    },

    // Strands for Science
    scienceStrands: {
      livingThings: "Êtres Vivants",
      materials: "Matériaux",
      energy: "Énergie",
      earth: "Terre et Espace"
    },

    // Strands for Social Science
    socialScienceStrands: {
      identity: "Identité et Culture",
      place: "Lieu et Environnement",
      time: "Temps et Changement",
      society: "Organisation Sociale"
    },

    // Assessment types
    assessmentTypes: {
      formative: "Évaluation Formative",
      summative: "Évaluation Sommative",
      diagnostic: "Évaluation Diagnostique",
      quiz: "Quiz",
      test: "Test",
      exam: "Examen",
      project: "Projet",
      presentation: "Présentation",
      portfolio: "Portfolio"
    },

    // Days of week
    days: {
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi"
    },

    // Lesson plan elements
    lessonPlan: {
      objective: "Objectif",
      introduction: "Introduction",
      development: "Développement",
      practice: "Pratique",
      conclusion: "Conclusion",
      homework: "Devoirs",
      materials: "Matériel",
      duration: "Durée",
      minutes: "minutes"
    }
  },

  // Roll Call Page
  rollCall: {
    title: "Appel",
    selectClass: "Sélectionner la Classe",
    markAttendance: "Marquer la Présence",
    present: "Présent",
    absent: "Absent",
    late: "En Retard",
    excused: "Excusé",
    saveAttendance: "Enregistrer la Présence",
    attendanceSaved: "Présence enregistrée avec succès",
    noStudents: "Aucun élève dans cette classe",
    date: "Date",
    student: "Élève",
    status: "Statut",
    notes: "Notes"
  },

  // Grade Book Page
  gradeBook: {
    title: "Carnet de Notes",
    selectClass: "Sélectionner la Classe",
    selectTerm: "Sélectionner le Trimestre",
    selectSubject: "Sélectionner la Matière",
    addAssessment: "Ajouter une Évaluation",
    enterGrades: "Entrer les Notes",
    saveGrades: "Enregistrer les Notes",
    gradesSaved: "Notes enregistrées avec succès",
    student: "Élève",
    assessment: "Évaluation",
    grade: "Note",
    average: "Moyenne",
    total: "Total",
    percentage: "Pourcentage",
    comment: "Commentaire",
    terms: {
      term1: "Trimestre 1",
      term2: "Trimestre 2",
      term3: "Trimestre 3",
      term4: "Trimestre 4"
    }
  },

  // Timetable Page
  timetable: {
    title: "Emploi du Temps",
    myTimetable: "Mon Emploi du Temps",
    classTimetable: "Emploi du Temps de la Classe",
    period: "Période",
    time: "Heure",
    subject: "Matière",
    teacher: "Enseignant",
    room: "Salle",
    break: "Pause",
    lunch: "Déjeuner",
    assembly: "Assemblée"
  },

  // My Attendance Page
  myAttendance: {
    title: "Ma Présence",
    today: "Aujourd'hui",
    history: "Historique",
    summary: "Résumé",
    signIn: "Pointer l'Arrivée",
    signOut: "Pointer le Départ",
    signedIn: "Arrivée Pointée",
    signedOut: "Départ Pointé",
    onSite: "Sur Site",
    remote: "À Distance",
    totalDays: "Jours Totaux",
    presentDays: "Jours de Présence",
    absentDays: "Jours d'Absence",
    lateDays: "Jours de Retard"
  },

  // Students Page
  students: {
    title: "Élèves",
    addStudent: "Ajouter un Élève",
    editStudent: "Modifier l'Élève",
    studentDetails: "Détails de l'Élève",
    firstName: "Prénom",
    lastName: "Nom",
    dateOfBirth: "Date de Naissance",
    gender: "Sexe",
    male: "Masculin",
    female: "Féminin",
    class: "Classe",
    guardian: "Tuteur",
    contact: "Contact",
    address: "Adresse",
    enrollmentDate: "Date d'Inscription",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif"
  },

  // Report Cards
  reportCards: {
    title: "Bulletins Scolaires",
    term: "Trimestre",
    year: "Année",
    student: "Élève",
    class: "Classe",
    subject: "Matière",
    grade: "Note",
    comment: "Commentaire",
    teacherComment: "Commentaire de l'Enseignant",
    principalComment: "Commentaire du Directeur",
    attendance: "Présence",
    conduct: "Comportement",
    effort: "Effort",
    excellent: "Excellent",
    good: "Bien",
    satisfactory: "Satisfaisant",
    needsImprovement: "À Améliorer",
    print: "Imprimer le Bulletin",
    publish: "Publier les Bulletins"
  },

  // Notifications
  notifications: {
    title: "Notifications",
    markAsRead: "Marquer comme lu",
    markAllAsRead: "Tout marquer comme lu",
    noNotifications: "Aucune notification",
    newNotification: "Nouvelle notification",
    viewAll: "Voir toutes"
  },

  // Error messages
  errors: {
    loadingFailed: "Échec du chargement",
    saveFailed: "Échec de l'enregistrement",
    deleteFailed: "Échec de la suppression",
    networkError: "Erreur de réseau",
    unauthorized: "Non autorisé",
    notFound: "Non trouvé",
    serverError: "Erreur du serveur",
    validationError: "Erreur de validation",
    requiredField: "Ce champ est requis",
    invalidEmail: "Email invalide",
    invalidDate: "Date invalide"
  },

  // Success messages
  success: {
    saved: "Enregistré avec succès",
    deleted: "Supprimé avec succès",
    updated: "Mis à jour avec succès",
    created: "Créé avec succès",
    sent: "Envoyé avec succès"
  },

  // Junior Secondary (Collège) - Years 7-10 / 7e-10e
  juniorSecondary: {
    title: "Programme Secondaire",
    subtitle: "7e-10e - Programme National du Vanuatu",
    yearLevels: {
      year7: "7e (Année 7)",
      year8: "8e (Année 8)",
      year9: "9e (Année 9)",
      year10: "10e (Année 10)"
    },
    subjects: {
      francais: "Français",
      mathematiques: "Mathématiques",
      sciencesSociales: "Sciences Sociales",
      sciencesFondamentales: "Sciences Fondamentales",
      anglais: "Anglais",
      agriculture: "Agriculture",
      catechese: "Catéchèse",
      sport: "Sport",
      bibliotheque: "Bibliothèque"
    },
    // Class teacher
    professeurPrincipal: "Professeur Principal"
  },

  // Dashboard Home Page
  dashboardHome: {
    welcome: "Bienvenue",
    goodMorning: "Bonjour",
    goodAfternoon: "Bon après-midi",
    goodEvening: "Bonsoir",
    todayClasses: "Cours d'aujourd'hui",
    upcomingAssessments: "Évaluations à venir",
    recentActivity: "Activité récente",
    quickActions: "Actions rapides",
    viewAll: "Voir tout",
    noClasses: "Pas de cours aujourd'hui",
    noAssessments: "Pas d'évaluations à venir"
  },

  // Classes Page
  classesPage: {
    title: "Mes Classes",
    selectClass: "Sélectionner une classe",
    studentCount: "Nombre d'élèves",
    schedule: "Horaire",
    viewDetails: "Voir les détails",
    noClasses: "Aucune classe assignée"
  },

  // Analytics/Overview Page
  analytics: {
    title: "Aperçu",
    overview: "Vue d'ensemble",
    attendance: "Présence",
    performance: "Performance",
    trends: "Tendances",
    thisWeek: "Cette semaine",
    thisMonth: "Ce mois",
    thisYear: "Cette année",
    attendanceRate: "Taux de présence",
    averageGrade: "Note moyenne",
    classAverage: "Moyenne de classe"
  },

  // AI Lesson Planner
  aiLessonPlanner: {
    title: "Planificateur de Cours IA",
    generate: "Générer",
    regenerate: "Régénérer",
    selectSubject: "Sélectionner la matière",
    selectYear: "Sélectionner l'année",
    selectTopic: "Sélectionner le sujet",
    lessonObjective: "Objectif du cours",
    duration: "Durée",
    generating: "Génération en cours...",
    savePlan: "Enregistrer le plan",
    printPlan: "Imprimer",
    myLibrary: "Ma Bibliothèque"
  },

  // Resources Page
  resourcesPage: {
    title: "Ressources pour Élèves",
    uploadResource: "Téléverser une ressource",
    downloadResource: "Télécharger",
    resourceType: "Type de ressource",
    subject: "Matière",
    yearLevel: "Niveau",
    noResources: "Aucune ressource disponible"
  },

  // Submissions Page
  submissions: {
    title: "Soumissions et Corrections",
    pending: "En attente",
    graded: "Corrigé",
    returned: "Retourné",
    markSubmission: "Corriger",
    viewSubmission: "Voir la soumission",
    addFeedback: "Ajouter un commentaire",
    score: "Note",
    submittedAt: "Soumis le",
    submittedBy: "Soumis par"
  },

  // Leave Requests
  leaveRequests: {
    title: "Demandes de Congé",
    newRequest: "Nouvelle demande",
    startDate: "Date de début",
    endDate: "Date de fin",
    reason: "Motif",
    status: "Statut",
    pending: "En attente",
    approved: "Approuvé",
    rejected: "Refusé",
    approve: "Approuver",
    reject: "Rejeter"
  },

  // Master Timetable
  masterTimetable: {
    title: "Emploi du Temps Principal",
    allClasses: "Toutes les classes",
    conflicts: "Conflits",
    checkConflicts: "Vérifier les conflits",
    noConflicts: "Aucun conflit détecté",
    room: "Salle",
    teacher: "Enseignant"
  }
};

// Helper function to check if user is from French school
export const isFrenchSchool = (user) => {
  return user?.school_id && FRENCH_SCHOOL_IDS.includes(user.school_id);
};

// Helper function to get translation
export const getTranslation = (user, path, defaultValue) => {
  if (!isFrenchSchool(user)) {
    return defaultValue;
  }
  
  const keys = path.split('.');
  let value = frenchTranslations;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return defaultValue;
    }
  }
  
  return value || defaultValue;
};

export default frenchTranslations;
